export default __webpack_public_path__ + "static/media/gm-qt-girl.0860ac8d.webp";